export enum VenueSectionContext {
    EVENT = 'EVENT',
    SUBSCRIPTION_TYPE = 'SUBSCRIPTION_TYPE'
}
